// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState } from "vuex";
import config from "../../../../../../share/src/config";
import { sortSystems } from "../../../../util/obd/system";
import { pushFunctionList } from "../../../../router/obd";

export default {
  name: "obdSystemList",
  data() {
    return {
      sortedSystems: null,
    };
  },

  components: {},

  computed: {
    ...mapState({
      obdSystems: state => state.obd.systems,
    }),
  },

  methods: {
    /**
     * OBD個別診断一覧画面へ遷移する。
     * @param {string} systemNo システム No
     */
    async initCommunication(systemNo) {
      // OBDシステムトップからリダイレクト
      pushFunctionList(this, systemNo, undefined);
    },

  },

  created(){
    this.sortedSystems = sortSystems(this.obdSystems, "systemName", config.ASC);
  },

  mounted() {
    // ツリーから機能一覧または各機能ノードが選択されて遷移してきた時は、機能一覧ページにリダイレクトする
    if (this.$route?.query?.systemNo) {
      // 機能一覧ページにリダイレクト
      pushFunctionList(this, this.$route.query.systemNo, this.$route.query.funcKey);
      return;
    }
  },
};
